import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const heroSlides = [
  {
    id: "movie-01",
    title: "星际远征",
    tag: "电影 · 科幻",
    desc: "远征舰队穿越星云寻找新家园，一场关于勇气与信念的深空之旅。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20giant%20spaceship%20drifting%20through%20a%20glowing%20orange%20and%20teal%20nebula%2C%20deep%20space%20stars%2C%20dramatic%20rim%20lighting%2C%20dark%20moody%20atmosphere%2C%20high%20contrast%2C%20film%20grain&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: "movie-03",
    title: "深海回响",
    tag: "电影 · 冒险",
    desc: "万米海沟之下，一段来自海洋深处的神秘回响正等待被听见。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20underwater%20wide%20shot%20of%20a%20deep%20ocean%20trench%20with%20a%20glowing%20submarine%2C%20shafts%20of%20light%20from%20the%20surface%2C%20dark%20blue-green%20water%2C%20mysterious%20atmosphere%2C%20high%20contrast&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: "movie-07",
    title: "极地密码",
    tag: "电影 · 悬疑",
    desc: "深入极地冰原的科考队，正在解开冰层之下沉睡的秘密。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20frozen%20arctic%20landscape%20with%20an%20expedition%20tent%2C%20aurora%20lights%20in%20the%20sky%2C%20cold%20blue%20tones%20with%20warm%20orange%20lantern%20glow%2C%20dramatic%20scale%2C%20high%20contrast&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: "tv-01",
    title: "长夜将明",
    tag: "电视剧 · 悬疑",
    desc: "一桩旧案牵连出新的线索，一群人在长夜中守候黎明的到来。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rainy%20dark%20alley%20with%20a%20lone%20figure%20under%20a%20warm%20street%20lamp%2C%20cool%20teal%20shadows%2C%20moody%20atmosphere%2C%20high%20contrast%2C%20film%20grain&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
  {
    id: "movie-15",
    title: "铁血航线",
    tag: "电影 · 动作",
    desc: "风暴笼罩的海域上，一艘孤舰肩负着全船人的信念破浪前行。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20warship%20cutting%20through%20stormy%20seas%20at%20dawn%2C%20dramatic%20clouds%2C%20cool%20teal%20water%20with%20orange%20sky%2C%20high%20contrast%2C%20film%20grain&width=1600&height=900&seq=hero-05&orientation=landscape",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[index];

  return (
    <section className="relative w-full h-[560px] md:h-[640px] lg:h-[720px] overflow-hidden">
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={s.image}
            alt={`${s.title} 焦点视频背景`}
            title={`${s.title} - 黄瓜视频App焦点推荐`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/70 to-background-950/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-black/30" />

      <div className="relative z-10 w-full h-full px-4 md:px-8 pb-14 md:pb-20 flex flex-col justify-end">
        <div className="max-w-2xl animate-fade-up" key={slide.id}>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-950 text-xs font-label font-medium">
            <i className="ri-fire-fill w-4 h-4 flex items-center justify-center" />
            热门推荐
          </span>
          <p className="mt-4 text-sm md:text-base text-accent-300 font-label tracking-wide">{slide.tag}</p>
          <h2 className="mt-2 text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            {slide.title}
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl">
            {slide.desc}
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${slide.id}`}
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-950 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-fill w-5 h-5 flex items-center justify-center" />
              立即观看
            </Link>
            <Link
              to="/download"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-950/60 border border-foreground-700/50 hover:border-primary-500 text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line w-5 h-5 flex items-center justify-center" />
              下载App
            </Link>
          </div>
        </div>

        <div className="mt-10 flex items-center gap-3">
          {heroSlides.map((s, i) => (
            <button
              key={s.id}
              type="button"
              aria-label={`切换到 ${s.title}`}
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                i === index ? "w-10 bg-primary-500" : "w-5 bg-foreground-700/50 hover:bg-foreground-600"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}